import Vue from 'vue';
import { mapGetters } from 'vuex';
import { LOAD_SUBSCRIPTION } from 'src/store/types';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    computed: {
        ...mapGetters(['subscription']),
        overUserLimit() {
            return this.subscription?.membershipCount >= this.subscription?.userLimit;
        },
        formattedUserLimit() {
            const analystLimit = this.subscription?.userLimit;
            const analystCount = this.subscription?.membershipCount;
            if (!Number.isInteger(analystLimit)) {
                return `${analystCount} creator users.`;
            }
            else if (analystLimit === analystCount) {
                return `This site has no free seats for creator users: (${analystCount}/${analystLimit} used).`;
            }
            return `${analystLimit - analystCount} out of ${analystLimit} creator seats remaining.`;
        },
        formattedViewerUserLimit() {
            const viewerLimit = this.subscription?.viewerUserLimit;
            const viewerCount = this.subscription?.viewerMembershipCount;
            if (!Number.isInteger(viewerLimit)) {
                return `${viewerCount} explorer users.`;
            }
            else if (viewerLimit === viewerCount) {
                return `This site has no free seats for explorer users: (${viewerCount}/${viewerLimit} used).`;
            }
            return `${viewerLimit - viewerCount} out of ${viewerLimit} explorer seats remaining.`;
        },
        formattedDate() {
            if (!this.subscription?.termEnd) {
                return 'No end date set.';
            }
            const localDate = new Date(this.subscription?.termEnd).toDateString();
            return localDate;
        },
        siteRowLimit() {
            return Math.min(10000000, this.subscription?.projectRowLimit ?? Infinity);
        },
        siteColumnLimit() {
            return Math.min(500, this.subscription?.projectColumnLimit ?? Infinity);
        },
        siteEnforcedRow() {
            return this.subscription?.enforceRowLimit;
        },
    },
    beforeMount() {
        this.$store.dispatch({ type: LOAD_SUBSCRIPTION });
    },
    methods: {
        number: FormatUtils.number,
        subscription_visited() {
            this.$analytics.track.site.subscriptionView();
        },
    },
});
